'use client';

import DallasDialog from '@ui/Dallas/Dialogs/DallasDialog';
import DallasStack from '@ui/Dallas/Stack/DallasStack';
import DallasText from '@ui/Dallas/Text/DallasText';
import DallasButton from '@ui/Dallas/Buttons/DallasButton/DallasButton';
import styles from './TermsOfServiceDialog.module.scss';
import { useTermsOfServiceAcceptanceStatus } from '@ui/shared/TermsOfServiceProvider/TermsOfServiceProvider';
import acceptTermsOfServiceUpdates from '@lib/api/client/accept-tos-updates';
import DallasSpinner from '@ui/Dallas/ProgressIndicators/Spinner/DallasSpinner';
import DallasImageTruckSmarterLogo from '@ui/Dallas/Images/TruckSmarterLogo/DallasImageTruckSmarterLogo';
import TermsOfServiceCopy from '@ui/Copy/TermsOfServiceCopy';
import useFetchTermsOfServiceCopy from '@ui/Copy/useFetchTermsOfServiceCopy';

export default function TermsOfServiceDialog() {
  const { data: tosData, isLoading: isTosDataLoading } =
    useFetchTermsOfServiceCopy({ tosType: 'UPDATE' });
  const { termsOfServiceAcceptanceStatus, setTermsOfServiceAcceptanceStatus } =
    useTermsOfServiceAcceptanceStatus();
  if (tosData == null || termsOfServiceAcceptanceStatus !== false) {
    return null;
  }

  return (
    <DallasDialog
      className={styles.root}
      padding="3xl"
      content={
        <DallasStack alignHorizontal="center" flex={false}>
          <DallasImageTruckSmarterLogo width={260} color="brand" />
          <DallasText variant="headerBoldM">
            {'Terms of Service and Privacy Policy'}
          </DallasText>
          <TermsOfServiceCopy
            textItems={tosData.termsOfServiceTextParts}
            color="dark"
          />
          <DallasStack gap="md" alignHorizontal="center" direction="row">
            <DallasButton
              color="primary"
              label="Agree"
              className={styles.primaryButton}
              disabled={isTosDataLoading || !tosData}
              addOnStart={isTosDataLoading ? <DallasSpinner /> : undefined}
              onClick={() => {
                acceptTermsOfServiceUpdates();
                setTermsOfServiceAcceptanceStatus?.(true);
              }}
            />
          </DallasStack>
        </DallasStack>
      }
    />
  );
}
